module.exports = __webpack_public_path__ + "static/media/promotion_percent_datepicker_icon.36141419.svg";